import { useRequest } from 'ahooks';
import type { Options, Result } from 'ahooks/lib/useRequest/src/types';
import type { BaseModel, IExtra } from './createRequest';
export function createUseRequest<IModels extends BaseModel, U extends keyof IModels = keyof IModels>(
    fetchFn: (...args: any[]) => Promise<IModels[U]['responses']>
) {
    return function useHttp<T extends keyof IModels>(
        url: T,
        payload?: any | null,
        options?: {
            extra?: IExtra;
        } & Options<IModels[T]['responses'], [any]>
    ): Result<IModels[T]['responses'], [any]> {
        const { extra, ...requestOptions } = options || {};

        return useRequest<IModels[T]['responses'], any>(async params => {
            const res = await fetchFn(url, params || payload, extra);
            return res;
        }, requestOptions);
    };
}
